/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.vendor', {
      url: '/:id/vendor',
      template: '<vendor></vendor>',
      resolve: {
        /* @ngInject */
        case: ($http, $stateParams, $state, Session, VENDOR_ID) => {
          const user = Session.read('userinfo') || {};
          const isVendor = user.client.type === 'VENDOR';

          if (isVendor) {
            return $http.put(`/case/${$stateParams.id}/allocate`, { vendorId: user.client_id })
              .then(() => $state.go('main.cases.fill', { id: $stateParams.id }));
          }

          return $http
            .get('/clientVendor')
            .then(({ data = [] }) => {
              const isDefaultVendor = data.find(v => (v.id === VENDOR_ID));

              return isDefaultVendor
                ? $http.put(`/case/${$stateParams.id}/allocate`, { vendorId: VENDOR_ID })
                  .then(() => $state.go('main.cases.fill', { id: $stateParams.id }))
                : data;
            });
        },
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/vendor/vendor.routes.js